import moment from 'moment';

const parsePoWithDates = po => ({
  ...po,
  spendDate: (po.spendDate) ? po.spendDate.value: null,
  approvedTs: (po.approvedTs) ? moment(po.approvedTs.value).format('YYYY-MM-DD'): null,
})

export { parsePoWithDates }